import React from 'react';
import { injectIntl } from 'react-intl';
import * as ContentMargin from '@commoncomponents/frontend-components/dist/components/ContentMargin';
import * as ModalModule from '@commoncomponents/frontend-components/dist/components/ModalRoot/components';
import * as Text from '@commoncomponents/frontend-components/dist/components/Text';
import AlertIcon from '@commoncomponents/frontend-components/dist/components/AlertIcon';
const ContactWithSuperAdminModal = ({ organizationAccountsList, intl: { formatMessage }, contactWithSuperAdminTranslations: { header, description }, onClick, }) => {
    let superAdminEmails = [];
    if (organizationAccountsList) {
        const superAdminAccounts = organizationAccountsList.filter((account) => {
            return account.role === 'SUPER_ADMIN';
        });
        superAdminAccounts.map((account) => superAdminEmails.push(account.boxIdentifier));
    }
    return (React.createElement(ModalModule.Wrapper, null,
        React.createElement(ContentMargin.Bottom, { size: 1.5 },
            React.createElement(ModalModule.Title, { onClose: onClick, variant: "center" },
                React.createElement(AlertIcon, { variant: "INFO" }))),
        React.createElement(ContentMargin.Top, { size: 1.5 },
            React.createElement(ModalModule.Content, null,
                React.createElement(Text.Subheading1, null, header && formatMessage(header)),
                React.createElement(ContentMargin.Top, { size: 3 },
                    React.createElement(Text.Body, null, description &&
                        formatMessage(description, {
                            superadmins: (React.createElement("strong", { style: { wordWrap: 'break-word' } }, superAdminEmails.join(', '))),
                        })))))));
};
export default injectIntl(ContactWithSuperAdminModal);
